export default {
  discoveryOffers: [],
  selectedOffer: null,
  viewedInCart: false
}
